import React from 'react'

import {
  BooleanField,
  FieldSpec,
  LinkedField,
  PaginatedTable,
  RelatedLinkedField,
  SkuHealthField,
  SkuUnitField,
  ValueField,
} from 'src/components/Table'
import {ListTableProps} from './types'

const fieldOptions: {[key: string]: FieldSpec} = {
  sku: {id: 'sku', label: 'SKU', renderer: LinkedField(ValueField)},
  client: {id: 'client', label: 'Client', ordering: 'account__name', renderer: RelatedLinkedField(ValueField, 'name')},
  productName: {id: 'productName', label: 'Product', ordering: 'product__name', renderer: ValueField},
  product: {id: 'product', label: 'Product', ordering: 'product__name', renderer: RelatedLinkedField(ValueField, 'name')},
  numAvailable: {id: 'numAvailable', label: 'Number of Units Available', ordering: 'num_available', renderer: SkuUnitField},
  numReserved: {id: 'numReserved', label: 'Number of Units in Orders', ordering: 'num_reserved', renderer: SkuUnitField},
  numAwaitingShipment: {id: 'numAwaitingShipment', label: 'Number of Units Awaiting Shipment', ordering: 'num_awaiting_shipment', renderer: SkuUnitField},
  isActive: {id: 'isActive', label: 'Is Active', ordering: 'is_active', renderer: BooleanField},
  // health is just for global counts to validate selection vs default sku
  health: {id: 'storageHealth', label: 'Health', ordering: 'storage_health', renderer: SkuHealthField},
}

export const SkuListTable = (props: ListTableProps) => {
  const {paginator, fields, extraActions, exportConfig} = props

  return (
    <>
      <PaginatedTable
        title="SKUs"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        actions={extraActions}
        exportConfig={exportConfig}
      />
    </>
  )
}
